var map = {
	"./qilin-f-stage1-hungry.png": "2237",
	"./qilin-f-stage2-hungry.png": "5be3",
	"./qilin-f-stage3-hungry.png": "b9d4",
	"./qilin-f-stage4-hungry.png": "4642",
	"./qilin-f-stage5-hungry.png": "1a1b",
	"./qilin-f-stage6-hungry.png": "958f",
	"./qilin-f-stage7-hungry.png": "366c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9b5";